// GridDiscoverUsers.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LoadingImageResource from '../../img/img_loading_white_20.svg';
import {
  InfiniteScroller,
  ScrollItem,
} from '../component/InfiniteScroller.jsx';
import UserFeedItem from '../container/UserFeedItem.js';

export const GridDiscoverUsers = ({
  nextPage,
  isNextPageFetching,
  userIds,
  category,
  isAuthed,
  withChatLink,
  fetchFeeds,
  sendChatStart,
  ...otherProps
}) => {
  const loadMore = () => {
    if (category) {
      return fetchFeeds({ type: category, page: nextPage });
    }
  };

  useEffect(() => {
    if (!category) return;

    const nextTick = setTimeout(() => {
      fetchFeeds({ type: category, page: 1 });
    }, 0);

    return () => {
      clearTimeout(nextTick);
    };
  }, [isAuthed, category, fetchFeeds]);

  return (
    <StyledGridDiscoverUsers>
      <ScrollerWrapper>
        <InfiniteScroller
          pageStart={1}
          threshold={100}
          hasMore={nextPage != null}
          isFetching={isNextPageFetching}
          loadMore={loadMore}
        >
          <ListWrapper>
            <ScrollItem
              loader={
                <UserWrapper>
                  <LoadingWrapper>
                    <LoadingIcon src={LoadingImageResource} alt="loading" />
                  </LoadingWrapper>
                </UserWrapper>
              }
            >
              {userIds.map(userId => (
                <UserFeedItemWrapper key={userId} withChatLink={withChatLink}>
                  <UserFeedItem
                    id={userId}
                    withChatLink={withChatLink}
                    {...otherProps}
                  />
                </UserFeedItemWrapper>
              ))}
            </ScrollItem>
          </ListWrapper>
        </InfiniteScroller>
      </ScrollerWrapper>
    </StyledGridDiscoverUsers>
  );
};

GridDiscoverUsers.propTypes = {
  userIds: PropTypes.array,
  category: PropTypes.string,
  nextPage: PropTypes.number,
  isNextPageFetching: PropTypes.bool,
  isAuthed: PropTypes.bool,
  withChatLink: PropTypes.bool,
  fetchFeeds: PropTypes.func,
  sendChatStart: PropTypes.func,
};

GridDiscoverUsers.defaultProps = {
  userIds: [],
  category: null,
  nextPage: null,
  isNextPageFetching: false,
  isAuthed: false,
  withChatLink: false,
  fetchFeeds: () => null,
  sendChatStart: () => null,
};

const StyledGridDiscoverUsers = styled.main``;

const ScrollerWrapper = styled.div`
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
`;

const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(104px, 1fr));
  grid-column-gap: 8px;
  grid-row-gap: 20px;
`;

const UserWrapper = styled.div``;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 0.6;
`;

const LoadingIcon = styled.img`
  width: 32px;
  height: auto;
`;

const UserFeedItemWrapper = styled.div`
  cursor: ${({ withChatLink }) => (withChatLink ? 'pointer' : 'auto')};
`;

export default GridDiscoverUsers;
